import React from "react";
import { Box, Container, Paper, Table, styled } from "@mui/material";
import { TableBody, TableCell, TableContainer } from "@mui/material";
import { TableHead, TableRow, Typography } from "@mui/material";
import { Grid } from "@mui/material";
import moment from "moment";

const Summary = styled(Box)({
  paddingLeft: "15px",
  paddingRight: "15px",
  paddingTop: "5px",
  display: "flex",
  justifyContent: "space-between",
});
const SummaryHead = styled(Box)({
  borderTop: "solid 1px #000000",
  borderBottom: "solid 1px #000000",
  height: "50px",
  backgroundColor: "#F0F0F0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "7px",
});
const SummarySec = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  marginTop: "10px",
  marginBottom: "10px",
  height: "250px",
});
const Footer = styled(Box)({
  backgroundColor: "#F0F0F0",
  marginBottom: "20px",
  border: "none",
  height: "50px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

export const ComponentToPrint = React.forwardRef((props, ref) => {
  const companyCode = localStorage.getItem("companyCode");
  let titleType = "";
  if (companyCode == 7149 || companyCode == 1178) {
    titleType = "Estimate";
  } else {
    titleType = "Invoice";
  }

  const getPageMargins = () => {
    return `@page { margin:  25px  20px 25px 25px !important; }`;
  };

  return (
    <Box ref={ref} sx={{ background: "white" }}>
      <style>{getPageMargins()}</style>
      <Container>
        <Grid container spacing={2} sx={{ mt: "10px" }}>
          <Grid item lg={6} md={6} sm={6} xs={6}>
            {props?.sale == "true" && (
              <img
                style={{ maxHeight: "100px", maxWidth: "100px" }}
                src={localStorage.getItem("invoiceImage")}
                alt="logo"
              />
            )}
            {!props.sale && props?.bill?.image?.url && (
              <img
                style={{ maxHeight: "100px", maxWidth: "100px" }}
                src={props?.bill?.image?.url}
                alt="logo"
              />
            )}
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={6}>
            <Typography>{titleType}</Typography>
          </Grid>

          <Grid item lg={6} md={6} sm={6} xs={6}>
            From :
            <Box
              sx={{
                padding: "5px",
                background: "#F0F0F0",
                "&:hover": {
                  outlineStyle: "solid",
                  outlineColor: "#257eff",
                  outlineWidth: "2px",
                  cursor: "pointer",
                },
              }}
            >
              <Typography style={{ fontWeight: "bold", marginBottom: "10px" }}>
                {props?.bill?.senderDetails?.companyName}
              </Typography>
              <Typography>
                {props?.bill?.senderDetails?.firstName ||
                props?.bill?.senderDetails?.lastName
                  ? props?.bill?.senderDetails?.firstName +
                    " " +
                    props?.bill?.senderDetails?.lastName
                  : ""}
              </Typography>
              <Typography>{props?.bill?.senderDetails?.addressOne}</Typography>
              <Typography> {props?.bill?.senderDetails?.addressTwo}</Typography>
              <Typography style={{ marginBottom: "10px" }}>
                {props?.bill?.senderDetails?.country}
              </Typography>
              <Typography>{props?.bill?.senderDetails?.phone}</Typography>
              <Typography>{props?.bill?.senderDetails?.email}</Typography>
              <Typography style={{ marginBottom: "10px" }}>
                {props?.bill?.senderDetails?.website}
              </Typography>
              {props?.bill?.senderDetails?.taxNumber && (
                <>
                  <Typography>Tax Registration Number</Typography>
                  <Typography>
                    {props?.bill?.senderDetails?.taxNumber}
                  </Typography>
                </>
              )}
            </Box>
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={6}>
            To :
            <Box
              sx={{
                padding: "5px",
                background: "#F0F0F0",
                "&:hover": {
                  outlineStyle: "solid",
                  outlineColor: "#257eff",
                  outlineWidth: "2px",
                  cursor: "pointer",
                },
              }}
            >
              <Typography style={{ fontWeight: "bold", marginBottom: "10px" }}>
                {props?.bill?.receiverDetails?.companyName}
              </Typography>
              <Typography>
                {props?.bill?.receiverDetails?.firstName ||
                props?.bill?.receiverDetails?.lastName
                  ? props?.bill?.receiverDetails?.firstName +
                    " " +
                    props?.bill?.receiverDetails?.lastName
                  : ""}
              </Typography>
              <Typography>
                {props?.bill?.receiverDetails?.addressOne}
              </Typography>
              <Typography>
                {" "}
                {props?.bill?.receiverDetails?.addressTwo}
              </Typography>
              <Typography style={{ marginBottom: "10px" }}>
                {props?.bill?.receiverDetails?.country}
              </Typography>
              <Typography>{props?.bill?.receiverDetails?.phone}</Typography>
              <Typography>{props?.bill?.receiverDetails?.email}</Typography>
              <Typography style={{ marginBottom: "10px" }}>
                {props?.bill?.receiverDetails?.website}
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid
          style={{ marginTop: "10px", marginBottom: "10px" }}
          container
          spacing={4}
        >
          <Grid item lg={6} md={6} sm={6} xs={6}>
            <Typography>{titleType} Number</Typography>

            <Typography>{props?.bill?.invoiceNumber}</Typography>
          </Grid>
          <Grid
            style={{ display: "flex", justifyContent: "space-between" }}
            item
            lg={6}
            md={6}
            sm={6}
            xs={6}
          >
            <Box>
              <Typography>{titleType} Date</Typography>

              <Typography>
                {moment(props?.bill?.invoiceDate).format("DD-MM-YYYY")}
              </Typography>
            </Box>
            <Box>
              <Typography>Due Date</Typography>
              <Typography>
                {moment(props?.bill?.dueDate).format("DD-MM-YYYY")}
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <TableContainer
          style={{ marginTop: "20px", marginBottom: "20px" }}
          component={Paper}
        >
          <Table style={{ minWidth: 550 }} aria-label="simple table">
            <TableHead style={{ backgroundColor: "grey" }}>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Item</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Rate</TableCell>
                <TableCell>Tax</TableCell>
                <TableCell>Sub Total</TableCell>
              </TableRow>
            </TableHead>
            {props?.bill?.items?.map((item, index) => {
              return (
                <TableBody key={index} className="page-break">
                  <TableRow>
                    <TableCell component="th" scope="row">
                      {index + 1}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {item?.itemName}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {item?.quantity}
                    </TableCell>

                    <TableCell component="th" scope="row">
                      {item?.rate}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {item?.taxPercent + " " + "%"}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {item?.subTotal}
                    </TableCell>
                  </TableRow>
                </TableBody>
              );
            })}
          </Table>
        </TableContainer>

        <SummarySec>
          <Box style={{ width: "40%" }}>
            <SummaryHead>
              <Typography variant="h6">{titleType} Summary</Typography>
            </SummaryHead>

            <Summary>
              <Typography>Sub Total : </Typography>
              <Typography>PKR {props?.bill?.subTotal}</Typography>
            </Summary>
            <hr />

            <Summary>
              <Typography>Tax : </Typography>
              <Typography>PKR {props?.bill?.tax}</Typography>
            </Summary>
            <hr />

            <Summary>
              <Typography>Total : </Typography>
              <Typography>PKR {props?.bill?.total}</Typography>
            </Summary>
            <hr />
          </Box>
        </SummarySec>
        <Footer>
          <Typography>{props?.bill?.footerText}</Typography>
        </Footer>
      </Container>
    </Box>
  );
});
